export enum TypeDialog {
	ATENCAO = "atencao",
	SUCESSO = "sucesso",
	ERRO = "erro",
}
